module.exports = __webpack_public_path__ + "img/pathology.22e29184.png";